export async function getImageFileSize(url: string | undefined) {
  if (!url) return "";
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.status}`);
    }
    const blob = await response.blob();
    return blob.size;
  } catch (error) {
    console.error("Error fetching image size:", error);
    return null;
  }
}

export function formatFileSize(bytes: number | null) {
  if (!bytes) return undefined;

  if (bytes === null) return "Unknown";
  const mb = bytes / (1024 * 1024);
  if (mb >= 1) {
    return `${mb.toFixed(2)} MB`;
  }
  const kb = bytes / 1024;
  return `${kb.toFixed(2)} KB`;
}
